import { getOrComputeConnectorLookup } from './getConnectorLookupCache';
import { getSvgDataUrl } from './getSvgDataUrl';

import apiFirstImage from '~/common/images/api-first.svg';
import nonExistentComponentImage from '~/common/images/nonexistent-component.svg';
import { useConnectorStore } from '~/scenes/Build/scenes/FlowBuilder/stores';

export const nonExistentComponentCapsule =
  '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';

export type BadgeInfo = {
  [key: string]: {
    icon: string;
    name: string;
  };
};

export type Connector = {
  experimental?: boolean;
  category?: string;
  resourceId?: string;
  type?: string;
  id?: string;
  key?: string;
  name?: string;
  title?: string;
  description?: string;
  descriptionPtbr?: string;
  subCategory?: string;
  toplevelCategory?: string;
  image: string;
  shape: 'ellipse' | 'diamond' | 'round-pentagon' | 'hexagon';
  icon?: string;
  iconURL?: string;
  jsonExample?: string;
  configExample?: Record<string, unknown>;
  catalog?: {
    name?: string;
  };
  service?: string;
  jsonSchema?: Record<string, unknown>[];
  jsonCapsuleEnable?: boolean;
  jsonSchemaCapsule?: Record<string, unknown>[];
  jsonSchemaEdge?: Record<string, unknown>[];
  documentationURL?: string;
  documentation?: string;
  visual?: boolean;
  versionMajor?: string;
  versionMinor?: string;
  realmMaintainer?: {
    name?: string;
  };
  isSuggestion?: boolean;
  deprecated?: boolean;
  exists?: boolean;
  environment?: string;
  fullEndpoint?: string;
  keyName?: string;
  colorAccent?: string;
  colorBackground?: string;
  iconName?: string;
  badgeInfo?: BadgeInfo;
  isTrigger?: boolean;
};

export type Connectors = {
  components: Connector[];
  triggers: Connector[];
  capsulesConsumers: {
    iconURL?: string | undefined;
    id?: string;
    image?: string;
    name: string;
    capsuleServices: Connector[];
    keyName: string;
    jsonExample: string;
    realmMaintainer?: {
      name?: string;
    };
  }[];
  librariesConsumers: {
    name: string;
    libraryServices: Connector[];
  }[];
  libraries: {
    name: string;
    description: string;
    iconName: string;
    icon: string;
    iconURL: string;
    libraryServices: Connector[];
  }[];
};
export const defaultTriggerImage =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODBweCIgaGVpZ2h0PSI4MHB4IiB2aWV3Qm94PSIwIDAgODAgODAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Y21wdC10cmlnZ2VyLW5vdC1jb25maWd1cmVkPC90aXRsZT4KICAgIDxnIGlkPSJ0ZW1wIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MDkuMDAwMDAwLCAtNTAzLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iY21wdC10cmlnZ2VyLW5vdC1jb25maWd1cmVkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MDkuMDAwMDAwLCA1MDMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLUNvcHktOCIgZmlsbD0iIzdBNzhCOCIgY3g9IjQwIiBjeT0iNDAiIHI9IjQwIj48L2NpcmNsZT4KICAgICAgICAgICAgICAgIDxnIGlkPSJwbGF5LWNpcmNsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMDAwMDAwLCAxNS4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNC44LDQ5LjYgQzM4LjUsNDkuNiA0OS42LDM4LjUgNDkuNiwyNC44IEM0OS42LDExLjEgMzguNSwwIDI0LjgsMCBDMTEuMSwwIDAsMTEuMSAwLDI0LjggQzAsMzguNSAxMS4xLDQ5LjYgMjQuOCw0OS42IFogTTMuMiwyNC44IEMzLjIsMTIuOTMgMTIuODEsMy4yIDI0LjgsMy4yIEMzNi42NywzLjIgNDYuNCwxMi44MSA0Ni40LDI0LjggQzQ2LjQsMzYuNjcgMzYuNzksNDYuNCAyNC44LDQ2LjQgQzEyLjkzLDQ2LjQgMy4yLDM2Ljc5IDMuMiwyNC44IFogTTM2LjM3LDIzIEwxOC43NywxMi4zIEMxNy4xOSwxMS40MiAxNS4yLDEyLjU1IDE1LjIsMTQuNCBMMTUuMiwzNS4yIEMxNS4yLDM3LjA0IDE3LjE4LDM4LjE4IDE4Ljc3LDM3LjMgTDM2LjM3LDI3LjIgQzM4LjAxLDI2LjI5IDM4LjAxLDIzLjkyIDM2LjM3LDIzIFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=';
const getConnector = (rawType: string, rawName?: string): Connector => {
  const type = rawType?.toLowerCase();
  const name = rawName?.toLowerCase().replace(/\./, '');

  const defaultTrigger: Connector = {
    name: rawName,
    type: rawType,
    shape: 'ellipse',
    image: defaultTriggerImage,
    exists: false,
    isTrigger: true
  };

  if (type === 'start-track' || type === 'starter-node') return defaultTrigger;

  const { connectors } = useConnectorStore.getState();

  const nonExistentCapsule: Connector = {
    name: rawName,
    shape: 'hexagon',
    image: nonExistentComponentCapsule,
    type: 'capsule',
    exists: false
  };
  const nonExistentLibrary: Connector = {
    name: rawName,
    shape: 'hexagon',
    image: nonExistentComponentImage,
    type: 'library',
    exists: false
  };
  const nonExistentComponent: Connector = {
    name: rawName,
    type: rawType,
    shape: 'ellipse',
    image: nonExistentComponentImage,
    exists: false
  };

  if (type === 'trigger') {
    const trigger = connectors.triggers.find(
      t => t.name && name && t.name === name
    );

    if (trigger) {
      const image = trigger.iconURL
        ? trigger.iconURL
        : `data:image/png;base64,${trigger.icon}`;

      return { ...trigger, shape: 'ellipse', image, exists: true };
    }

    return defaultTrigger;
  }

  if (type === 'capsule') {
    const foundEntry = connectors.capsulesConsumers
      .map(capsuleCollection => {
        const foundCapsule = capsuleCollection.capsuleServices.find(
          currentCapsule =>
            currentCapsule.name &&
            currentCapsule.name.replace(/\./, '') === name
        );
        return foundCapsule ? { capsuleCollection, foundCapsule } : null;
      })
      .find((entry): entry is NonNullable<typeof entry> => entry != null);

    if (foundEntry) {
      const { capsuleCollection, foundCapsule } = foundEntry;
      const capsule = {
        ...foundCapsule,
        exists: true,
        image: `"${getSvgDataUrl(foundCapsule.iconURL)}"`,
        realmMaintainer: capsuleCollection.realmMaintainer
      };
      return capsule;
    }
    return nonExistentCapsule;
  }

  if (type === 'library') {
    const foundLibrary = connectors.librariesConsumers?.reduce<
      Connector | undefined
    >((acc, libConsumer) => {
      if (acc) {
        return acc;
      }
      return libConsumer.libraryServices.find(
        currentLibrary =>
          currentLibrary.name && currentLibrary.name.replace(/\./, '') === name
      );
    }, undefined);

    if (foundLibrary) {
      return {
        ...foundLibrary,
        exists: true,
        image: `"data:image/png;base64,${foundLibrary.icon}"`
      };
    }

    return nonExistentLibrary;
  }

  const component = connectors.components.find(currentComponent => {
    const isNameEquals =
      currentComponent.name && currentComponent.name.toLowerCase() === name;

    const jsonExample: { name?: string } = currentComponent.jsonExample
      ? JSON.parse(currentComponent.jsonExample)
      : {};
    const isJsonExampleNameEquals =
      jsonExample.name && jsonExample.name.toLowerCase() === name;

    if (type === 'connector') return isNameEquals || isJsonExampleNameEquals;

    const isTypeEquals =
      currentComponent.type && currentComponent.type.toLowerCase() === type;

    return isNameEquals || isTypeEquals || isJsonExampleNameEquals;
  });

  if (component && name?.startsWith('api-first:') && type === 'choice') {
    return {
      ...component,
      image: apiFirstImage || '',
      exists: true
    };
  }

  if (component && name?.startsWith('mcp-server:') && type === 'tool-router') {
    return {
      ...component,
      image: component?.iconURL || apiFirstImage,
      exists: true
    };
  }

  if (component) {
    let image = '';
    if (component.iconURL) {
      image = component.iconURL;
    } else if (component.icon) {
      image = `data:image/png;base64,${component.icon}`;
    }
    return { ...component, image, exists: true };
  }

  return nonExistentComponent;
};
export default (rawType: string, rawName?: string): Connector => {
  const id = `${rawType}-${rawName}`;
  return getOrComputeConnectorLookup(id, () => getConnector(rawType, rawName));
};
